<div class="global-loading-container" *ngIf="isLoading">
  <app-loading-overlay 
    [isLoading]="true"
    [message]="loadingMessage"
    [spinnerDiameter]="60"
    spinnerColor="#FF9137"
    overlayColor="rgba(255,255,255,0.95)">
  </app-loading-overlay>
</div>


